import axios from "axios";

window.log("process.env", process.env);

const HTTP_REQUEST_HEADER = {
  "Accept-Language": "pt-BR",
  "Content-Type": "application/json",
};

export const BASE_URL = "";

const instance = axios.create({
  baseURL: BASE_URL,
  headers: HTTP_REQUEST_HEADER,
});

const interceptors = { request: [], response: [] };

export default { client: instance, options: { interceptors } };



// WEBPACK FOOTER //
// ./src/services/state/middlewares/axios/clients/http-client.js